import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NotificationService } from '../../../../notification/data/notification.service';
import { Notification } from '../../../../notification/data/notification';
import { Observable, Subscription, timer } from 'rxjs';
import { map, debounceTime, filter, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { WsService } from '../../../../data/ws.service';
import { WsUpdateResponce } from '../../../../data/ws-update-responce';
import { trackEntityById } from 'projects/core/src/public-api';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-history-block',
    templateUrl: './history-block.component.html',
    styleUrls: ['./history-block.component.scss']
})
@RxJSUnsubscribe
export class HistoryBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    projectId: number;

    notifications: Notification[];
    notificationMap$: Map<string, Notification[]>;

    historyIsLoading = false;

    nfsReaded = false;

  wsSub: Subscription;
    trackEntityById = trackEntityById;

    constructor(
        protected notificationService: NotificationService,
        protected wsService: WsService
    ) { }

    ngOnInit() {
        this.notificationService.markProjectNfsAsRead(this.projectId).subscribe(() => {
            this.nfsReaded = true;
        })
    }

    initToRealTimeUpdates() {
    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Notification>>('/topic/update/model.notification.Notification', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.project.id === this.projectId),
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.getHistory();
            })
    }

    loadHistory() {
        if (!this.notificationMap$) {
            this.historyIsLoading = true;
            this.getHistory();
        }
        this.initToRealTimeUpdates();
    }

    getHistory() {
        this.notificationService.getNotificationsForProject(this.projectId).pipe(
            map(notifications => {
                const notificationMap = new Map<string, Notification[]>()
                notifications.forEach(notification => {
                    const key = moment(notification.createdTime).format('L')
                    if (!notificationMap.has(key)) {
                        notificationMap.set(key, [])
                    }
                    notificationMap.get(key).push(notification)
                })

                this.notificationMap$ = notificationMap
                this.historyIsLoading = false;
            })
        ).subscribe(nfs => {
        })
    }

    returnZero() {
        return 0
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
